import { Box, Image } from "@chakra-ui/react";
import imgContent01 from "../../../assets/images/content/bg/content-blackbox-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-blackbox-02.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-blackbox-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-blackbox-02.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-blackbox-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-blackbox-02.png";

import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { DomainList } from "../../../assets/datas/ConstantLists";
import ProgressSlider from "../../../components/ProgressSlider";

const BlackBox = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    },
  ];

  return (
    <Box w={"100%"}>
      <Image 
        src={contents[0][screen]} 
        w={"100%"} 
        alt="" 
      />
      <ProgressSlider datas={DomainList}/>
      <Image 
        src={contents[1][screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default BlackBox;